<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

// TODO: deselect impossible municipalities based on province and municipality select (e.g. Amsterdam should be removed if only Friesland is selected)

export default {
  name: "PlaceSearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "places_filtered",
    }),
  },
  data() {
    return {
      placeholder: "Alle plaatsen",
      filtername: "plaatsen",
      type: "plaatsen",
    };
  },
};
</script>
